import IPixelMapDay from "@interfaces/pixel-map-day.interface";

const januaryMap: Array<IPixelMapDay> = [
	{
		status: "good",
		icon: "flare",
		title: "New Year's Day",
		reason: `
			I celebrated the new year by going to the rooftop of my house and watching the fireworks with my cousins, as I have for the past 2 new year celebrations. I felt really bloated, like I had a lot to eat. I was with my friends in a call when we all celebrated the New Year's Day but we had celebrated separately when the countdown struck. We shortly got back in the call and I got to watch them complete some of the story in God of War before going to sleep.

			Even after that, I still couldn't sleep for some reason. My sleep schedule was wrecked and it took a while for me to sleep, not to mention that my cousins and other family members were still outside singing karaoke at 5 a.m. When I finally slept, I had a horrible feeling in my stomach because I ate so much spicy food. I had a full day's rest, though, and woke up at around 1. For the rest of the day, I mostly greeted my friends a happy new year.

			I got into a long call with my friends for most of the evening, just watching them play God of War and scary videos, then talking about other things in life. It was fun, really fun, to say the least.
		`,
		spotify: {
			artist: "Taylor Swift",
			album: "Lover",
			song: "Paper Rings",
			link: "https://open.spotify.com/track/4y5bvROuBDPr5fuwXbIBZR?si=8e0decec947742d6"
		},
		resonatedLyrics: [
			"I like shiny things, but I'd marry you with paper rings",
			"Uh huh, that's right",
			"Darling, you're the one I want, and",
			"I hate accidents except when we went from friends to this",
			"Uh huh, that's right",
			"Darling, you're the one I want",
			"In paper rings, in picture frames, in dirty dreams",
			"Oh, you're the one I want"
		]
	},
	{
		status: "excellent",
		reason: `
			After spending most of the past month cooped up in my room and my house, I was finally able to go outside today with my sister. I'm also glad that I was able to take an additional day off for today, which I honestly appreciated.

			We went to Makati to take a photo of the Christmas tree at Greenbelt. It was nice to walk around Greenbelt and to explore around the area. It honestly makes me miss the feeling of working in Makati and calling this place "my area after work." We basically just circled around it because the Japanese restaurant we wanted to go to was closed, so we just ate at Sumo Niku.

			We walked around and tried to buy an electric kettle, but couldn't so we just got Starbucks instead. When I got home, I just accompanied my friends to watch them play God of War. It was fun, but our time was cut short after they wanted to sleep. I got to eat dinner with my sister and the food was pretty good, too. All in all, today was pretty nice. I'm glad to have gone outside today.
		`,
		spotify: {
			artist: "Charli XCX",
			album: "SUCKER",
			song: "Boom Clap",
			link: "https://open.spotify.com/track/094RugjgLW6CdPLOJctBZ3?si=4a61ea1258b54c7c"
		},
	},
	{
		status: "bad",
		reason: `
			It was the first day I came back to work, and I was just piled with a lot of stuff that needed to be done. I was just busy and my body clock was shot because I wasn't used to waking up so early in the morning anymore haha.
		`,
		spotify: {
			artist: "Don Omar",
			album: "Meet The Orphans",
			song: "Danza Kuduro",
			link: "https://open.spotify.com/track/2a1o6ZejUi8U3wzzOtCOYw?si=10a41ea600a44175"
		}
	},
	{
		status: "good",
		icon: "stadia_controller",
		title: "God of War Complete!",
		reason: `
			I spent a good chunk of the day staying at Nicole's house for the birthday celebration. It was mostly me, catching up with my old friends in my current workplace, and chatting about life, career, playing games (during breaktime), and eating as well.

			When I got home, I got into a call with my friends and I watched them finish God of War. After that, I got to play Lucius.

			It was still a good day, I had fun for most of today, despite how difficult the evening was to get through. 
		`,
	},
	{
		status: "average",
		reason: `
			I spent most, if not the entire, day alone and just doing things by myself. I don't remember much aside from working during work hours, and working on my coding project after work. I wanted to join into a call with the RC, but I didn't and just observed them from afar.
		`,
		spotify: {
			artist: "Madonna",
			album: "Celebration (double disc version)",
			song: "Material Girl",
			link: "https://open.spotify.com/track/22sLuJYcvZOSoLLRYev1s5?si=7fb23ea93ebd4bf1"
		},
	},
	{
		status: "above-average",
		reason: `
			I spent most of the day with my friends in a call today, just playing games. We all decided to stream/play this new horror game that we saw on YouTube, and it was so scary. It really frightened me and it had been a really, really long time since I was terrified of a video game. Hollow Cocoon was really scary.

			After that, we spent the evening in a call, with me watching them play Sims 4 while I try to work on my coding project in the background. They asked me if I'm done with it, and I told them that I wasn't, then they told me to continue working on it and they left for bed shortly after.
		`,
		spotify: {
			artist: "Foster The People",
			album: "Torches",
			song: "Helena Beat",
			link: "https://open.spotify.com/track/4VbDJMkAX3dWNBdn3KH6Wx?si=d83fc33860fe4470"
		},
	},
	{
		status: "above-average",
		reason: `
			I pulled an all-nighter working on that programming project I had yesterday and I feel so groggy. I slept for 3 hours or so, during 8-11 a.m. or something. The morning was such a blur. I continued to work on my coding project after waking up. After I passed my work, I tried to get some much-needed rest and "me time" for a while.

			In the evening, I decided to cool off by going outside to BGC alone and walking around. It's been a while since I've done this, and I remember that my past times of going to BGC were always filled with anxious emotions, but now I'm not anymore. I'm thoroughly void of any anxious feelings from my days past. I keep circling back to Past Lives and the whole concept of *inyeon (인연)*, how destiny/fate eventually wills people together.

			I'm sure I've yet to meet the person I have 8,000 layers of *inyeon* with. I walked around, thinking of how my life in the future will be better if I take the paths I truly desire, and letting go of things that don't offer me growth anymore.

			Regardless, I had fun out in BGC. Some girl beat me consecutively at Wangan Midnight, I got to chill at my favorite Starbucks place, and I got to go outside and think. Also this one REO Speedwagon kept playing while I was on the ride home, it was nice and my evening was pretty peaceful afterward.
		`,
		spotify: {
			artist: "REO Speedwagon",
			album: "The Essential REO Speedwagon",
			song: "In My Dreams",
			link: "https://open.spotify.com/track/6lf1UPrmgF1lEWybjHw62g?si=64442516fa4b4bb2"
		},
		resonatedLyrics: [
			"We climb and climb and at the top we fly",
			"Let the world go on below us, we are lost in time",
			"And I don't know really what it means",
			"All I know is that you love me, in my dreams"
		]
	},
	{
		status: "above-average",
        icon: "emoji_nature",
        title: "Hollow Cocoon Co-Coomplete",
		reason: `
            My God, was Hollow Cocoon scary.

			I actually started out the day in a not-so-good state. I was feeling lonely and the morning didn't really get any better for me. I got a lot of work done in the morning and I had a few meetings as well. Lunch and the work in the afternoon was no different: busy, nothing noteworthy. Just work.

            After my shift ended, I was in a call with my friends, finishing the final parts of Hollow Cocoon. Honestly, I forgot how scary the game was after 1 day of not playing it. I've played a lot of horror games in my time, and I mean **a lot**, and this one really manages to scare me. Once things were done, I just watched scary videos of games with them and we ended the day fine. I also stayed with them during nighttime and got to watch more scary horror game videos with them. It was pretty fun and reminded me of the time where I would stay up with them and just watch Philippine horror videos with them until 3 a.m.
		`,
		spotify: {
			song: "Fashion Week - Remix",
			artist: "icarus",
			link: "https://open.spotify.com/track/259Q1p3LaDoho6UCYjSvQG?si=5383f51273994750",
			album: "Fashion Week - Remix"
		},
	},
	{
		status: "average",
		reason: `
            Nothing much happened today.

			In the morning, I got to talk and eat breakfast with my sister as I was working. We reminisced at old commercials and things from the past. She asked me if I would ever have a soulmate, some who shares the same interests in music, the same history, with anyone else. I told her that I wasn't sure, but I happily told her that it was her. I appreciate my little sister and how we get along well. We finished eating and I continued on with my busy day.

			Nothing remarkable happened during my course of work, but I was glad that Meryll suddenly reached out to me and offered to hang out with me. It was sweet that she invited me out of the blue, even though we would be missing Max. I also talked to the RC if they want to spend the next Saturday, the 20th. I got into a call with them but I didn't stay long because I just wanted to be by my lonesome for a bit.

			Also, after work, I got invited by my friends for a call and we only stayed on call for an hour or so. They played Read Dead Redemption 2 and it was okay. After leaving the call, I didn't have anything much to do.
		`,
		spotify: {
			song: "Alcohol-Free",
			artist: "TWICE",
			link: "https://open.spotify.com/track/0BTaaKT4RMbs5M73tOHX5Y?si=9380c093c09d46e9",
			album: "Taste of Love"
		},
	},
	{
		status: "above-average",
		icon: "eyeglasses",
	},
	{
		status: "above-average",
		icon: "local_fire_department",
		title: "Single's Inferno Season 3 Done!",
		reason: `
            We finally finished watching season 3 of Single's Inferno and it was thrilling as hell. I was really kept on the edge of my seat as to how things will unfold. I was watching it with my friends and they provided good comments, reactions throughout the show.

			After that, I felt anxious. A lot anxious. I had that feeling again where I felt like my life wasn't gonna go anywhere and I wanted to break out of my current life so bad. I tried to clean my room and fix my drawers in an attempt to have some semblance of progress. Then I came across this line from Neil deGrasse Tyson:

			>We had our vision statement. We were thinking about our future.<br />We weren't thinking about the **now**, we were thinking about the **tomorrow**.

			I'm torn between the stoic philosophy of just taking in and experiencing the "now" and my ever-burning desire to build and develop the future. While I want to honestly choose both, I haven't made up my mind and I'm left with just living in the present, while still feeling anxious from it.
		`,
		spotify: {
			song: "I'm Unhappy",
			artist: "aespa",
			link: "https://open.spotify.com/track/6fzio74FGqFFsenYkbGPzR?si=34c750e0c26643da",
			album: "MY WORLD - The 3rd Mini Album"
		},
	},
	{
		status: "average",
		reason: `
            I feel like this day mostly passed by.

			I spent some time with my friends in a call, but we didn't really do anything meaningful together. We just lingered around the call and we talked about the couples from Singles Inferno Season 3. It was fun, though, we were checking out the contestants and their Instagram accounts. We wondered if Gwan Hee and Hye Seon were still together, and found out that Hye Seon had taken a picture of Jessica from Girls' Generation, which honestly shocked us all.

			I also ate that extremely spicy KFC chicken meal that I've been wanting. It was so spicy, but I ate at the wrong time so it was kinda cold by the time I had to eat it. Also the store messed up my order, so I had to eat a spicy sandwich twice (the correct order and  the incorrect order). It made for a really bad combination because I think my stomach is still recovering from the spicy chao fan situation a few days ago.
			
			I really won't be surprised if I become acidic or have hyperacidity by the end of the year. I just slept for most of the evening and wasted time on YouTube Shorts.
		`,
		spotify: {
			song: "Fellas In Paris",
			artist: "JAY-Z, Kanye West",
			link: "https://open.spotify.com/track/1auxYwYrFRqZP7t3s7w4um?si=49e2d7f0109941e9",
			album: "Watch The Throne"
		},
	},
	{
		status: "excellent",
		icon: "movie",
		title: "Mall of Asia Gala with Meryll",
		reason: `
			Today was the first day of the year I was out with a friend! I was excited, but also *very* late haha. I thought I would be on time, but apparently, I wasn't. We both were able to meet up at 3 p.m., though, so we still got to meet in the afternoon.

			We decided to eat first after meeting up because we were both hungry and had missed our meals, so MoA Seaside was our next bet. We talked while on the way there, I told her about my prospects this year, and that I was hopeful about them. We both ate at this restaurant and I ordered squid for my appetizer, and squid again for my main course. Meryll got roast beef and we started talking again about various things, like how frustrated and bored I am with my current life situation and how I'm just waiting for it to end. We then talked to each other about our plans for the year and how we should visit Max in Antique for a week sometime this year. Thankfully, she treated me out as a gift so I'm glad.
	   
			We then visited Conrad Manila, we had no intention of doing anything there other than to stroll around. We were supposed to go to this cafe at MoA Sky Garden but we took a quick detour here. Thankfully, we stopped by Fully Booked and I was surprised that I bought something there. I **never** buy books at all, and I hate carrying bags with me so that honestly shocked me. But I decided to treat myself by buying 2 books: Diary of a Wimpy Kid (the first book in the series), and The Practice of Not Thinking: A Guide to Mindful Living. Between the two, I'm more excited to read the latter.
	   
			We got to stroll around the mall for some time more, we even got to buy some coffee at Starbucks. When it was time to go to the cinema, we had to stop by the concession stand to get the drinks and popcorn that we ordered. I had to be such a special person and get that black truffle flavor, which took the workers some time to make. It was such a weird flavor, I wasn't sure if I liked it or not. I think I'm leaning more toward "I liked it."
	   
			Both of us hurriedly ran to the cinema because we were late and we got to watch The Boy and the Heron. It was a good movie, definitely okay, and not far from Studio Ghibli's films that I've watched. It reminded me so much of Spirited Away, and that was the mindset I had for it moving forward. By the end, it was okay, although the ending was so abrupt for me. Meryll and I were seated apart, so we didn't talk much during the film. They were “couple seats” and I was closest to the dude to my left and Meryll was spaced away, so I had to lean in order to talk to her. Once the movie was done, we didn't have dinner and walked around MoA talking about love and relationships, how my current situation was tiring, and how callous I've grown from it; then her, talking about the guy she's dating and how her relationship with him has been, their difficulties and growing pains.
	   
			Once the mall had closed, we went back to MoA Seaside to talk more and reflect on various things in life. When that was done and it was around midnight, we decided to end the day there. She went away for a while and I bought some footlong hotdog, then we met up again and she saw me casually sitting on some bench just munching on a footlong. She got to book a ride first before I did, and the night ended there.

			The day was really nice to me. I got some stuff off my chest and I was able to feel so honest with someone. I haven't felt like this in a long time, and I just remembered how happy and energized I feel whenever I'm with my friends in person, as an extrovert. I've been cooped up in my room recently, so it was super nice to have had the day out with a friend.
		`,
		spotify: {
			song: "Panalangin",
			artist: "APO Hiking Society",
			link: "https://open.spotify.com/track/7hLLpJ6stoDmLP4GkjavDh?si=e26366d2265540db",
			album: "Ten Years Together"
		},
	},
	{
		status: "above-average",
		reason: `
			My Sunday was pretty quiet. I'm glad I got to catch up with a few friends and tasks today. I got to reply to some letters, and got to read a good chunk on one of the books I bought yesterday. I enjoyed my time reading, however distracted I was.

			My friends invited me for a call today and I got to watch them play for a few hours before they had to go someplace. After that, I mostly spent most of my time catching up with friends through chat.
		`,
		spotify: {
			song: "Mad at Disney",
			artist: "salem ilese",
			link: "https://open.spotify.com/track/0BVPAjPQx7Zetk9RDQCC3W?si=66ee94e024d349ff",
			album: "Mad at Disney"
		},
		resonatedLyrics: [
			"My fairy grandma warned me",
			"Cinderella's story",
			"Only ended in a bad divorce"
		]
	},
	{
		status: "below-average",
		reason: `
			Things were okay by the late evening, though. I got into a call with my friends and they played Red Dead Redemption 2.
		`,
		spotify: {
			song: "Boom, Boom, Boom, Boom!!",
			artist: "Vengaboys",
			link: "https://open.spotify.com/track/5N6M8yDiMV32T6Rkzh8EbW?si=f7a126cc384641d8",
			album: "The Party Album"
		},
	},
	{
		status: "above-average",
		reason: `
			I found some old cringey posts on LinkedIn that I posted 9+ years ago. I don't know why I made a LinkedIn profile as a grade 10 high school student, but I am glad not a lot of people noticed my old posts.

			In the evening, I spent the most of it with my friends and we all watched No One Gets Out Alive on Netflix, then we watched some episodes of the first season of The Tudors.
		`,
		spotify: {
			song: "California Gurls",
			artist: "Katy Perry",
			link: "https://open.spotify.com/track/1GhbQDYGEOjyFwfT8lojcx?si=694670e756dd416d",
			album: "Teenage Dream"
		},
		resonatedLyrics: [
			"California girls, we're unforgettable",
			"Daisy Dukes, bikinis on top",
			"Sun-kissed skin so hot, we'll melt your popsicle",
			"Oh-oh-oh-oh-oh-oh, oh, oh-oh-oh-oh-oh",
			"California girls, we're undeniable",
			"Fine, fresh, fierce, we got it on lock",
			"West Coast represent, now put your hands up",
			"Oh-oh-oh-oh-oh-oh, oh, oh-oh-oh-oh-oh",
		]
	},
	{
		status: "special",
		icon: "move_up",
		title: "You Made the Transfer, Man!",
		reason: `
			On October 30, 2022, NASCAR racer Ross Chastain pulled off a legendary video game move that's never been successfully done in NASCAR racing: [wall riding](https://www.youtube.com/watch?v=sOY9p5gFa5Q&pp=ygUXcm9zcyBjaGFzdGFpbiB3YWxsIHJpZGU%3D). Chastain pulled off 1 unexpected move that shocked the crowd, got him a spot in the championship, and cemented his legacy in NASCAR racing history. Upon finishing the race, these words can be heard from a member of Chastain's crew:

			> You made the transfer! You made the transfer, man! That was f---ing ridiculous dude! That was wild man, that was wild! I don't know how long you've been sitting on that move but that was f---ing incredible.

			To that effect, that's sort of how I felt today. I feel like I pulled off something so hairbrained, something totally unexpected, that I didn't even know I would successfully pull off until it did—shocking everyone who knew of it. I'm happy, but at the same time, I can't rest easy just yet knowing how much I still have to achieve. I made the transfer, but the championship is still there.

			Today wasn't an ordinary day for me. A year ago, I would've thought that today would just be the same day.

			I ate so much, too. I knew I had to diet for a bit yesterday and I made the right call by doing so. Regardless, I *still* feel like I overate, though. I hope I lose this weight soon.

			For the evening, I was in a call with my friends and they introduced me to a new game series: Fears to Fathom. I played the 1st episode: Home Alone, then the 2nd episode: Norwood Hitchhike, and finally the 3rd episode: Carson House by the end of the night. All games were really frightening and it unsettled me, but I really do like playing horror games.
		`,
		spotify: {
			artist: "Don Omar",
			album: "Meet The Orphans",
			song: "Danza Kuduro",
			link: "https://open.spotify.com/track/2a1o6ZejUi8U3wzzOtCOYw?si=10a41ea600a44175"
		}
	},
	{
		status: "excellent",
		reason: `
			Today was a usual workday for me, getting tasks done and catching up on the tickets that I've missed.

			In the afternoon, someone and I had to go out and have dinner. We both got to SM Bicutan at relatively the same time and we headed directly to Sumo Niku. It was pretty funny when we got our food because the grill for our table wasn't working. Not only that, but I spilled water on my phone. Both made for really funny scenarios. She also remarked how I sounded sick and I told her that I've had a stuffed nose all week for no reason. We both also were getting frustrated at how the grill wasn't cooking any of the beef.

			We moved tables and got to grilling and eating, talking about various things in life and where we're both headed. Once that was done, we headed to National Bookstore to buy a few things, at her request. We talked for a bit and even played around while we were in there. She showed me a coloring/counting book while I was in line to pay for things and that got a laugh out of me. By the end of it, we both were ready to go home and she booked a car first. She told me she'll play Red Dead Redemption again later and headed off. I booked a motorcycle but I couldn't play any music on the ride home because my charging port was still soaked. I felt productive when I got home so I organized the clothes outside and did some general cleaning before we both got into a call and I watched her play Red Dead Redemption 2, which capped the day off.
		`,
		spotify: {
			artist: "Maroon 5",
			album: "It Won't Be Soon Before Long",
			song: "Makes Me Wonder",
			link: "https://open.spotify.com/track/3PNOYDruQplC92lNc7mE9W?si=98f418bad81f4a81"
		},
		resonatedLyrics: [
			"Wake up, blood-shot eye",
			"Struggle to memorize",
			"The way it felt between your thighs",
			"Pleasure that made you cry",
			"It feels so good to be bad",
			"Not worth the aftermath, after that, after that",
			"Try to get you back"
		]
	},
	{
		status: "above-average",
		reason: `
			I called in sick today because I didn't feel well, I developed a fever by morning and I couldn't really do any work, much less move around, come morning. I decided to take a Biogesic and sleep it off, then I woke up at around noon or so. I got some food.

			Around the evening, I was feeling better but was mostly left alone to do my own things. I worked on an easter egg for my site that only triggers for 0.5% of visitors. I also talked and caught up with my friends like Loy, Meryll, Max. Since I couldn't really use my Steam account, I just browsed the Internet until the very late evening.
		`,
		spotify: {
			artist: "Ariana Grande",
			album: "thank u, next",
			song: "thank u, next",
			link: "https://open.spotify.com/track/3e9HZxeyfWwjeyPAMmWSSQ?si=03c0ab9fcbd244e5"
		},
		resonatedLyrics: [
			"Thought I'd end up with Sean",
			"But he wasn't a match",
			"Wrote some songs about Ricky",
			"Now I listen and laugh",
			"Even almost got married",
			"And for Pete, I'm so thankful",
			"Wish I could say, \"Thank you\" to Malcolm",
			"'Cause he was an angel"
		]
	},
	{
		status: "good",
		reason: `
			Today was the day I was supposed to meet with the RC for our planned get-together, and I was put up to the task of treating 10 of them because it was my birthday celebration. My morning would've been nice if only I'd slept at an earlier time, but I couldn't so I ended up starting my day at 1 p.m.

			There was still some spare time in my hands, as we were supposed to meet up at around 3:00-3:30 p.m., and I used my spare time to update my journal entries. I met up with them at BGC Forum at around 3:10 p.m. and we all caught up and talked about random things. JK asked me how I'm doing recently and I appreciated how intently Monica was listening in, and how JK responded. By 4:07 p.m. we got in and 7 of us were accounted for and Jaymz, Sean, and Denise eventually went inside the restaurant a few minutes later. William and Sydney sat in front of me and we were right by the TV which blasted K-Pop music. I saw a lot of Twice MVs and I sang to some of the songs there, I also saw aespa's Spicy and Hype Boy from NewJeans play, which was good.

			We ate **a lot** of food, especially the beef. We had several rounds of that beef-enoki thing that Samgyupsalamat had and it was pretty good. Sydney, William, and I had some trouble cutting up the pork meat into pieces which was pretty funny. While cooking and eating, we all caught up with how we were doing in our lives, a lot of us were wowed by Jaymz's outfit of choice because he either looked like an exorcist or a club owner. It rained a lot outside while we were eating, but thankfully it had subsided by the time we were done eating. A few of the group went to Starbucks first while the rest of us stayed to finish our food and use the whole 2 hours.

			Starbucks was our next stop and it didn't occur to me that I should give my Starbucks QR Promo Card for more stickers, so I just scanned 2 stars instead of the total 10 that we bought. It was the last day of collecting stickers and I absolutely failed at collecting enough stickers for a collectible this year, which kinda bummed me out. But it's okay since I'll just find some other way to get those.

			Our trip ended at Timezone where I sat down on a Wangan Midnight arcade cabinet to play my favorite racing game. Eventually the guys left and I was still playing at the arcade cabinet. I also loaded a lot of arcade credits to a wrong card (which I left at home), so I called my night over and just headed home. I didn't spend any of time with anyone else and just did some coding for my website, figuring out this service worker thing.

			I felt really disconnected from my friends, which kind of surprised me. But I guess it's because they were all couples, except for Jaymz and I. I guess it weirded me out because it felt like a group couples date more than anything.
		`,
		spotify: {
			artist: "AJR",
			song: "Way Less Sad",
			album: "OK ORCHESTRA",
			link: "https://open.spotify.com/track/6YIivt0G3ZUuNrM62jp9pL?si=4eae2689f05d486d"
		},
		resonatedLyrics: [
			"I should move",
			"'Cause New York is getting muddy out"
		]
	},
	{
		status: "good",
		reason: `
			My sister and I went out early today so we can have our late birthday celebration for me. We were supposed to visit Tim Ho Wan and try out that *hakaw* (shrimp dumplings) I've been wanting to try, but remembering that she's a picky eater, I just asked her to look at the menu and she asked to visit Nanyang instead. We got to BGC High Street and went inside this Bread Talk shop which also housed another restaurant in it. I thought this was just a Bread Talk shop, but apparently it had Nanyang inside of it as well.

			We ate at Nanyang and I liked the dish I was served, to an extent. I had some noodles with chicken and cheese, and I wish I had more of the chicken. The noodles were okay. I also had some toast at the side with 2 poached eggs, all were good but I was expecting a heavier meal since it would be the only thing I would eat today. Oh well. After eating, we headed to Timezone and I couldn't transfer the incorrectly-purchased credits from my old card into my main one. But I still got them transferred into a new card and I played Wangan Midnight with my sister. I tried to teach her how to drive with manual transmission in the game and I accomplished a few story mode missions as well, upgrading my car. We got to sing some karaoke afterwards and then walked around Fully Booked before heading home.

			Some time later, I got into a call with my friends and I was explaining something to them, and they played Red Dead Redemption 2 eventually. I was having a somewhat-bad 2 days recently because I'm dealing with really heavy stuff that I'm trying to keep under wraps, but I just couldn't hold back and waterworks happened. I don't think they noticed, though, but they soon noticed that my mood was off and they asked me about it. In my head, I was thinking whether or not I should tell them the things I'm *truly* worried about, but I just gave them a fib and it wasn't really the crux of my problem. I tried my best to nurse my mood and pretty soon I was OK enough, so to speak. I still felt down, of course. Doomscrolling on Instagram didn't really help my mood either, but I realized that I was doomscrolling and stopped myself.

			All in all, I think I had a good day, despite everything. I had someone to listen to my problems, I went out with my sister, I had fun singing karaoke. Even though my mood is still shot, it's not that bad for me to call it a bad day. I really wish I was in a far future where I'm truly happy, but I guess days like this'll do.
		`,
		spotify: {
			artist: "James Arthur",
			album: "Back from the Edge",
			song: "Say You Won't Let Go",
			link: "https://open.spotify.com/track/5uCax9HTNlzGybIStD3vDh?si=24dfcaec196d43f6"
		},
		resonatedLyrics: [
			"Then, you smiled over your shoulder",
			"For a minute, I was stone-cold sober",
			"I pulled you closer to my chest",
			"And you asked me to stay over",
			"I said, \"I already told ya",
			"I think that you should get some rest\"",
		]
	},
	{
		status: "below-average",
		reason: `
			I woke up with the worst feeling today, like I was exhausted and I didn't really feel okay in the morning. I just woke up to ask for a leave and slept for most of the morning off. When I woke up in the afternoon, I mostly felt okay. I was surprised that I woke up at around 3 p.m., I guess my body needed a lot of sleep. I got to order milk tea from my favorite store to feel better.

			In the evening, I had some spare time so I just adjusted some variables in my blog's theme. I got to join a call with my friends in the evening and things were fairly normal. I watched them play Red Dead Redemption 2 and I helped them catch their best horse, which was a white Arabian horse that they named Taylor (after Taylor Swift).
		`,
		spotify: {
			artist: "Guns N' Roses",
			album: "Appetite For Destruction",
			song: "Sweet Child O' Mine",
			link: "https://open.spotify.com/track/7snQQk1zcKl8gZ92AnueZW?si=193c50b4262742ff"
		},
	},
	{
		status: "bad",
		reason: `
			I was really busy today. I spent most of my day at work, but I couldn't really figure out anything properly. I overtimed and worked an extra hour and 30 before I went to bed to go to sleep.

			I woke up at around 8 and did some thinking. I wondered how I'm gonna flourish in my current situation. I decided to just fix my sleep schedule and take an AWS certification on my own, funded by my own money. After being tired so much, I just went back to sleep.
		`,
		spotify: {
			artist: "Ed Sheeran",
			album: "÷ (Deluxe)",
			song: "Perfect",
			link: "https://open.spotify.com/track/0tgVpDi06FyKpA1z0VMD4v?si=12dbb4f0906f4cea"
		},
	},
	{
		status: "above-average",
		reason: `
			Today was pretty calm and fair. I had expected turbulence and that things would not be okay again, but things turned out actually great. When I joined my friends for a call in the afternoon, they were playing Red Dead Redemption 2.

			I got to be in a call with my friends and with them still playing Red Dead Redemption 2, up until 8 p.m. After that, we watched the HBO show version of The Last of Us and they slowly slept after that. I called it in early today, surprisingly, and slept at around 10 p.m.
		`,
		spotify: {
			artist: "Lord Huron",
			album: "Strange Trails",
			song: "The Night We Met",
			link: "https://open.spotify.com/track/3hRV0jL3vUpRrcy398teAU?si=b4e6d69a1b1a491c"
		},
		resonatedLyrics: [
			"I had all and then most of you",
			"Some and now none of you",
			"Take me back to the night we met",
			"I don't know what I'm supposed to do",
			"Haunted by the ghost of you",
			"Oh, take me back to the night we met",
		]
	},
	{
		status: "above-average",
		reason: `
			I was mostly busy with work today, again, and I sought help from higher-ups after I found my current situation too frustrating and I couldn't figure it out anymore. They proposed a solution and I was able to work well with that solution. After that, my work continued as usual.

			In the evening, I got into a call with my friends and I watched them play Red Dead Redemption 2 for a few hours, before we all decided to wind down by watching The Last of Us, the HBO show. We were able to watch 2 episodes before we called the day.
		`,
		spotify: {
			artist: "aespa",
			album: "MY WORLD - The 3rd Mini Album",
			song: "'Til We Meet Again",
			link: "https://open.spotify.com/track/60Uio68M57PwKEgZxSutL6?si=5c1a91d89c7045ef"
		},
		resonatedLyrics: [
			"Sayin' goodbye now",
			"거짓말처럼 행복한",
			"우리가 빛난 오늘 밤",
		]
	},
	{
		status: "excellent",
		title: "It’s Been 5 years!",
		icon: "calendar_clock",
		reason: `
			I met Badet again after 5 years! She brought along her husband of 2 years and we all had dinner in BGC!

			I honestly cannot fathom how long it has been ever since I've seen her. I've kept up with my past workmates, and even attend some of their celebrations (as the "baby boy" of the company). But for Badet, we haven't kept up much and ony recently decided to see each other after she moved in with her husband. Her humor hasn't changed one bit, as she says, and I can clearly see that she still makes the same old jokes as she did in 2018-2019. We're still very close, despite not talking much for a very long time, which honestly surprised me.

			Before we met, I finished a lot of my major work duties and had my fair share of fun at a monthly company event, VHH. My friends are gonna be unavailable this evening and for tomorrow so it was the perfect time for me to meet and hang out with old friends. After a few hours of "me" time, I went to BGC and got there pretty early at around 7:40. Since they were doing church activities, I decided to play Wangan Midnight to kill the time and I got a lot of good wins. I progressed through the story enough to max out my car's tuning. An hour or so later, they arrived and I got to meet up with them.

			We ate at Samgyupsalamat again, which is kind of funny because I just ate there recently, just last week. And they treated me to dinner since they were so late (the meetup time was 8:00 p.m.). Funny enough, we only ordered beef and I believe I ate so much again. It was just me and Badet talking about their plans for the future as husband and wife, where they're going in life, and how I'm planning to change my life this year. Badet was really insisting me to go to Canada with them and I appreciate the gesture. Maybe in the future, if I don't have ties in this country, I might take them up on the offer.

			Once we were finished eating, we walked around for a bit to burn what we ate, and this is the part where I open up to Badet about my current situation. Like all of my friends I've told this story to, they gave me the advice that I should be following, but she praises me on doing what is necessary for my situation. She and her husband then share stories of their horrible trip to Cebu and we laugh about some things. They invited me to come over and use their PS5, or just play games at a gaming cafe when we have the time and I agreed. After that, we got a single car home that stopped by their and my place. On the car ride home, I was mostly trying to digest how much time had passed ever since I was in KVH. It's been 5 years and I still keep up with them, which was frighteningly weird. I got to catch up with Meryll a bit before going to bed, because we had originally planned to watch a movie this evening. But after that, I went to sleep.
		`,
		spotify: {
			artist: "One Direction",
			album: "Take Me Home (Expanded Edition)",
			song: "Kiss You",
			link: "https://open.spotify.com/track/4My8w8AA1JpG6E5SiAPvJL?si=3f5891f0401741e4"
		},
		resonatedLyrics: [
			"Oh, I just wanna show you off to all of my friends",
			"Making them drool down their chinny-chin-chins",
			"Baby, be mine tonight, mine tonight",
			"Baby, be mine tonight, yeah"
		]
	},
	{
		status: "above-average",
		reason: `
			I mostly slept for this day, I don't know why. I woke up around morning, as usual, but then I went back to sleep after taking some milk in the morning to calm this acidic feeling in my gut. I then woke up at around 1:00 p.m. with a large headache.

			In the afternoon, I was mostly watching videos of aespa and other things on my YouTube feed as I ate food. I tried doing some learning with that AWS course, but I kind of struggled with finishing a good chunk of it today. I also played Wipeout HD & Fury on my PS3 emulator today but eventually took a break from it. I feel like I wasted a lot of time today, not sure of what to do, but I tried my best to be productive. I didn't really join a call with my friends today because I was afraid of wasting my time, so I just wasted my time on some other things.
		`,
		spotify: {
			song: "Thirsty",
			artist: "aespa",
			link: "https://open.spotify.com/track/6nICBdDevG4NZysIqDFPEa?si=5500796610554d15",
			album: "MY WORLD - The 3rd Mini Album"
		},
		resonatedLyrics: [
			"조급한 생각은 no, no (ya)",
			"이건 또 너를 위한 감정인 거야 (woo)",
			"(Sip, sip, sip, sip) 그래서 난",
			"(Sip, sip, sip) So thirsty, thirsty, thirsty"
		]
	},
	{
		status: "above-average",
		reason: `
			Today was an average weekend at home. I woke up at around 10 to do some general things and eventually I joined a call with my friends around noon to watch them play Red Dead Redemption. They played for quite a bit, then they brought up the origin of the "I will never financially recover from this" meme. It was a show called Tiger King that starred some weirdo named Joe Exotic and we watched them for some episodes. They were about to pass out, and even slept for a good chunk of it, while I was eating my spicy KFC meal. The crew somehow got my order wrong again and, thankfully, I got another free sandwich. I'm pretty sure my stomach will never recover from this.

			I was right and, by the time it was evening, I had a really bad issue with burping so much. I can also feel my stomach acid rising. I was still in a call with my friends and we watched 2 episodes of The Last of Us show before they played more Red Dead Redemption 2 in the evening. After that, we just watched some general unsolved mysteries and stuff while they dozed off to sleep. That pretty much ended the day.
		`,
		spotify: {
			artist: "The Click Five",
			song: "Jenny",
			link: "https://open.spotify.com/track/3iT4vWUWxqsn4hFTkEaJCi?si=5fc96f1aa207469b",
			album: "Modern Minds and Pastimes (U.S. Version)"
		},
	},
	{
		status: "above-average",
		reason: `
			Monday began and it was work as usual. I resumed some of my tasks from last week and I had quite a few stuff to deal with today. My team gave out a survey for us and I gave them my honest opinions and expressed my circumstances there.

			While working, I also listened to old scary Filipino stories from Philippine Campfire Stories. For lunch, my sister wasn't around so I ordered take out and got Zark's Burgers, I got "The Jawbreaker" and some sides like fries and nachos. I finished the Jawbreaker with relative ease this time, which should sound off alarm bells because I had a hard time finishing it before. I'm going to die from my diet, for sure. The sides weren't as much as I had remembered ordering before—for better or worse—and it was expensive for the price. Eventually, I finished my work, and my sister arrived from her job interview in the evening. She got an offer and signed immediately and I told her some general tips about working.

			In the evening, I joined a call for a bit to watch my friends play Red Dead Redemption and then they all slept afterwards. It was still pretty early in the night and I saw the RC guys playing Valorant in the Discord server. I didn't want to join, I never even played Valorant with them, so I just focused on my AWS certification and took more of the lessons the current course I was taking. I burned a good chunk of it and had some spare time to browse the Internet and reply to my other friends on Slowly to pass some time, which ended the night.
		`,
		spotify: {
			song: "Lovefool",
			artist: "The Cardigans",
			link: "https://open.spotify.com/track/7aQjPecQdIuNd1sz3KCDhD?si=957853c2f8d742ef",
			album: "First Band On The Moon (Remastered)"
		},
		resonatedLyrics: [
			"Lately I have desperately pondered",
			"Spent my nights awake and I wonder"
		]
	},
	{
		status: "good",
		icon: "earbuds",
		title: "Earbuds in Vegas",
		reason: `
			Tuesday came with a lot of deliverables and deadlines on my plate today. I just had to finish a lot of them. Normally, dealing with a lot of tasks and work pains would turn this day sour for me, but some saving graces came through for my mood:
			
			- The Hangover (2009)
			- Katy Perry's "Waking Up In Vegas."

			I watched The Hangover over the course of the day because my mood was totally shot. I was "chest-deep in the dumps" kind of bad. But I remembered how The Hangover seemed like a fun movie and I have a thing for films I watched when I was in school, so I decided to watch it for the hell of it. It was super funny to me, I immediately imagined myself in a group with 3 other guys, having fun on a night out and just doing shit for the hell of it. It's kinda sad to think that I *used* to have that kind of friend group, but now I'm a lone wolf (or a lone star, heh) now, but thankfully my mind didn't fixate on that. It really boosted my mood and I rediscovered Katy Perry's "Waking Up In Vegas" because of it. It is such a hidden gem and I remember listening to that song a lot when I was in my early teens. My sister also got me free food in the afternoon, which probably helped me a lot.

			After work, I joined a call with my friends for a bit and watched them play Red Dead Redemption 2. The call ended and I decided to go outside so I can pick up that AWS training course, but in a different setting. I wanted to continue learning, but at my favorite hangout place this time: Starbucks 32nd Street but then my friends messaged that they'll play Red Dead Redemption 2 so soon. I asked them to play for a bit without me and they obliged. My wired earphones started to break and fail on my way there, though, so I decided to buy myself new earphones as a sort of gift. I got the Sony WF-C500. It's been a year since I've had wireless earbuds anyway, plus I am in love with wireless earbuds. It's a step down from my flagships WF-1000XM4 (sold) and Galaxy Buds Pro 2 (stolen), but it'll do since this is all I can afford right now. I promised I'll get myself any top earbuds once I pass all my AWS certifications. I eventually arrived at my favorite place in BGC, watched some parts of the current module to test out the earbuds and went home replaying "Waking Up In Vegas" to keep me hyped up on the way home.

			I got to join the call again while my friends were playing Red Dead Redemption to and I just hopped in the call. We talked about the game for a bit and it wasn't long before they went to sleep. I used the time after to continue my AWS certification training course as well as tinker around the AWS Management Console. I was going to write a blog post about the current state of my domain's architecture, but it was postponed. I just decided to do some other things which ended the day.
		`,
		spotify: {
			song: "Waking Up In Vegas",
			artist: "Katy Perry",
			link: "https://open.spotify.com/track/28RZ8tNiWmTYISN51VpnNO?si=77c4175091934c49",
			album: "One Of The Boys"
		},
		resonatedLyrics: [
			"You gotta help me out",
			"It's all a blur last night",
			"We need a taxi",
			"'Cause you're hungover and I'm broke"
		]
	},
	{
		status: "good",
		reason: `
			I didn't really do much today aside from sleep. I didn't get any sleep at all in the morning. I decided to watch The Hangover Part II (2011) to burn the time. I was, however, able to recover enough sleep in the morning. When I woke up, I was able to get into a call with my friends. We were just talking and they were singing a song from Moana. I told them that I've never actually watched Moana before and they suggested that we watch Moana (2016). I really liked the story and I can't believe I sat on it for this long.

			After watching, they asked me what other Disney movie I missed and they recommended Cinderella (2015). We planned to watch it after 1 episode of Downton Abbey. Then we watched the pilot episode of Downton Abbey for the fun of it. It's been a long time since we watched it, I know the last time was July of last year, so I couldn't remember the story that much. We finished 1 episode and I still remember a good chunk of the plot, thankfully. After Downton Abbey, we watched Cinderella and they made a lot of jokes during the film. I learned a lot of fun trivia items about the movie while we were watching, and we exchanged a lot of jokes during it. After that, they all left to sleep for a bit and I decided to do some other things.

			In the background of it all, I was managing my domain transfer. I had decided to migrate my DNS and registrar from Cloudflare to Amazon, then use Route53 for my DNS. It was pretty seamless, I was able to remove the registrar locks and transfer all of my DNS records to Amazon. The whole process took around an hour or so and I was able to extend dartegnian.com for 1 year, following another registrar transfer. I've moved from Zoom.PH to Google Domains, then Cloudflare to Amazon in the past years and I'm hoping to make Amazon/AWS my home as I pursue a path in taking up AWS.

			The day ended with me sleeping throughout most of the evening. I don't think I recall waking up for more than 2 minutes. I don't know why, but I slept through the whole evening. But I enjoyed my time awake, and I really enjoyed it no matter how short it was.
		`,
		spotify: {
			song: "I Ain't Worried",
			artist: "OneRepublic",
			link: "https://open.spotify.com/track/4h9wh7iOZ0GGn8QVp4RAOB?si=9f981751172345d3",
			album: "I Ain’t Worried (Music From The Motion Picture \"Top Gun: Maverick\")"
		},
	},
];

export default januaryMap;
